// 超過指定字數，則用...代替
export const textLengthFiltered = (text, length) => {
    if (text && text.length > length) {
        return text.replace(/&nbsp;/g, "").replace("<br>", "").replace(/\s/g, "").slice(0, length - 1) + "...";
    }
    return text;
};

// 亂數排序
export const shuffleData = (data) => {
    return [...data].sort(() => Math.random() - 0.5);
};
